import { Button, Col, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useState } from "react";

import { DocumentStruct } from "../common/Interfaces";
import DocumentTable from "../components/generic_components/documentTable_components/DocumentTable";
import ErrorMessage from "../components/generic_components/ErrorMessage";

import EditDate from "../components/changeApplicability_components/EditDate";
import ChangeModels from "../components/changeApplicability_components/ChangeModels";

export default function ChangeApplicability() {
  const location = useLocation();
  const changeApplicabilityState = location.state?.changeApplicabilityState;
  const selectedDocument: DocumentStruct = changeApplicabilityState.document;
  const [errorMessages, setErrorMessages] = useState<string[]>([]);
  const [showModelUpdate, setShowModelUpdate] = useState(false);

  return (
    <>
      <Row>
        <Col xs={12}>
          <h5>Document Information</h5>
        </Col>
      </Row>
      <Row className="padding-top">
        <Col xs={12}>
          <DocumentTable
            exclude={false}
            noAction={true}
            documentResults={[selectedDocument]}
          />
        </Col>
      </Row>
      {errorMessages.length > 0 && <ErrorMessage errors={errorMessages} />}

      <Row>
        <Col xs={12}>
          <h5>Change Applicability Level</h5>
        </Col>
      </Row>

      <Row className="padding-top">
        <Col xs={12}>
          <EditDate
            document={selectedDocument}
            onErrorMessages={setErrorMessages}
          ></EditDate>
        </Col>
      </Row>

      <Row>
        <Col className="d-flex  justify-content-start" xs={12}>
          <Button onClick={() => setShowModelUpdate(true)}>Edit models</Button>
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <ChangeModels
            document={selectedDocument}
            onErrorMessages={setErrorMessages}
            show={showModelUpdate}
          />
        </Col>
      </Row>
    </>
  );
}
